export const userStyles = theme => ({
  '& .grid-container': {
    display: 'flex',
    justifyContent: 'space-between',
  },
  '& .grid-container__col': {
    width: `calc(50% - ${theme.spacing(1)})`,
  },
})
